<template>
  <vue-page-wrapper :title="htmlTitle" :bread-crumbs="breadCrumbs">
    <v-card>
      <vue-card-title
        title="Value wise Clients"
        subtitle="Value wise clients"
        :icon="$getIcon('mdiAccountDetails')"
      >
      </vue-card-title>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="desserts"
        hide-default-footer
        disable-pagination
        mobile-breakpoint="0"
      >
        <template v-slot:item="props">
          <tr>
            <td>{{ props.item.name }}</td>
            <td class="text-right">
              <span>{{ getCurrency(props.item.opportunity) }}</span>
            </td>
            <td class="text-right">
              <span>{{ getCurrency(props.item.lead) }}</span>
            </td>
            <td class="text-right">
              <span>{{ getCurrency(props.item.deal) }}</span>
            </td>
            <td class="text-right">
              <span>{{ getCurrency(props.item.lost) }}</span>
            </td>
            <td class="text-right">{{ props.item.High }}</td>
            <td class="text-right">{{ props.item.Mid }}</td>
            <td class="text-right">{{ props.item.Low }}</td>
            <td class="text-right">{{ props.item.total }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </vue-page-wrapper>
</template>

<script>
import { getCurrency } from "@/utils/common";

export default {
  name: "ClientValue",
  created() {
    this.fetchStat();
  },
  data() {
    return {
      htmlTitle: "Client Value",
      breadCrumbs: [
        { text: "Reports", disabled: true },
        {
          text: `${this.$store.state.shell.currentOrganizationName}`,
          disabled: true
        }
      ],
      headers: [
        {
          text: "User",
          align: "start",
          sortable: false,
          value: "name"
        },
        {
          text: "Opportunity (NRs)",
          value: "opportunity",
          sortable: false,
          class: "text-end"
        },
        {
          text: "Lead (NRs)",
          value: "lead",
          sortable: false,
          class: "text-end"
        },
        {
          text: "Deal (NRs)",
          value: "deal",
          sortable: false,
          class: "text-end"
        },
        {
          text: "Lost (NRs)",
          value: "lost",
          sortable: false,
          class: "text-end"
        },
        { text: "High", value: "High", sortable: false, class: "text-end" },
        { text: "Mid", value: "Mid", sortable: false, class: "text-end" },
        { text: "Low", value: "Low", sortable: false, class: "text-end" },
        { text: "Total", value: "total", sortable: false, class: "text-end" }
      ],
      desserts: []
    };
  },
  methods: {
    fetchStat() {
      this.$axios.$get("api/v1/crm/report/client-value/").then(response => {
        this.desserts = response;
      });
    },
    getCurrency
  }
};
</script>
